import { env } from '@/env.mjs';

export const CONSENTS = `${env.NEXT_PUBLIC_ORDER_API_URL}/v3/consents`;
